import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { FleetCategory } from '../../dashboard/fleet/common/enums/fleet-category';
import { FleetTypeHelper } from '../../dashboard/fleet/common/helpers/fleet-type.helper';
import type { TelematicsItem } from '../interfaces/telematics/telematics-item';
import { FleetIdentifierPipe } from './fleet-identifier.pipe';

@Pipe({
  name: 'telematicsIdentifier',
})
export class TelematicsIdentifierPipe implements PipeTransform {
  private readonly fleetIdentifierPipe = inject(FleetIdentifierPipe);

  public transform(
    item: TelematicsItem,
    format: 'short' | 'long' = 'short',
  ): string {
    const vehicleData = FleetTypeHelper.isVehicle(item)
      ? item
      : item.assignedVehicle;
    const trailerData = FleetTypeHelper.isTrailer(item)
      ? item
      : item.assignedTrailer;

    const pipeFormat = format === 'short' ? 'registrationNumber' : 'dot';
    const vehicleIdentifier = this.fleetIdentifierPipe.transform(
      vehicleData,
      pipeFormat,
    );
    const trailerIdentifier = this.fleetIdentifierPipe.transform(
      trailerData,
      pipeFormat,
    );

    const category = item.generalInformation.category;
    if (trailerData || category === FleetCategory.SEMI_TRUCK) {
      return `${vehicleIdentifier} / ${trailerIdentifier}`;
    }
    return vehicleIdentifier;
  }
}
